export function getLoanPurposeEncoded(loanPurpose: string) {
    if (typeof loanPurpose === 'string') {
        return decodeURIComponent(loanPurpose).replaceAll(' ', '-')
    }
    return loanPurpose
}
